var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.173 9.67h1.8l.968 1.718h.046l.981-1.719h1.788l-1.765 2.954 1.834 2.953h-1.834l-1.003-1.754h-.047l-1.003 1.754H9.115l1.811-2.953-1.753-2.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.727 2.364a2.363 2.363 0 0 0-2.363 2.363v14.545a2.364 2.364 0 0 0 2.363 2.364h10.546a2.363 2.363 0 0 0 2.364-2.364V8.183a.606.606 0 0 0-.178-.428L14.246 2.54a.606.606 0 0 0-.428-.177h-7.09Zm-.814 1.549c.216-.216.509-.337.814-.337h6.84l4.857 4.858v10.838a1.152 1.152 0 0 1-1.151 1.152H6.727a1.151 1.151 0 0 1-1.151-1.152V4.727c0-.305.121-.598.337-.814Z"
  }))));
};
export default SvgExcel;